import { Controller } from 'stimulus';
import { gsap } from 'gsap';

export default class extends Controller {
  connect() { 
    gsap.fromTo(this.element, {
      autoAlpha: 0,
    }, {
      duration: 1,
      autoAlpha: 1,
    })
  }
}